import React from 'react';
import { Box, Typography, Fade, Paper } from '@mui/material';

const ChakraInfoPanel = ({ chakra }) => (
  <Fade in={!!chakra} timeout={400}>
    <Paper elevation={6} sx={{ p: { xs: 3, sm: 4 }, borderRadius: 4, borderTop: `6px solid ${chakra?.color}`, bgcolor: 'background.paper', minHeight: 320 }}>
      <Typography variant="h5" fontWeight={700} sx={{ color: chakra?.color, mb: 1, fontFamily: 'Playfair Display, serif' }}>
        {chakra?.name}
      </Typography>
      <Typography variant="subtitle1" sx={{ mb: 2, color: chakra?.color, fontWeight: 600 }}>
        {chakra?.location}
      </Typography>
      <Typography variant="body1" sx={{ mb: 2, color: 'text.primary' }}>
        {chakra?.description}
      </Typography>
      <Box sx={{ mb: 1 }}>
        <Typography variant="subtitle2" fontWeight={600} sx={{ color: chakra?.color }}>
          Emotional Associations
        </Typography>
        <Typography variant="body2" color="text.secondary">
          {chakra?.emotion}
        </Typography>
      </Box>
      <Box sx={{ mb: 1 }}>
        <Typography variant="subtitle2" fontWeight={600} sx={{ color: chakra?.color }}>
          Signs of Imbalance
        </Typography>
        <Typography variant="body2" color="text.secondary">
          {chakra?.imbalance}
        </Typography>
      </Box>
      <Box>
        <Typography variant="subtitle2" fontWeight={600} sx={{ color: chakra?.color }}>
          Healing Practices
        </Typography>
        <Typography variant="body2" color="text.secondary">
          {chakra?.practices}
        </Typography>
      </Box>
    </Paper>
  </Fade>
);

export default ChakraInfoPanel; 